import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AWS from "../../assets/images/aws.svg";
import Azure from "../../assets/images/azure.svg";
import GCP from "../../assets/images/gcp.svg";

import {
  Card,
  CardFooter,
  CardHeader,
  Typography,
  Button,
  CardBody,
} from "@material-tailwind/react";
import GetStarted from "../SecurityHub/CreateNewScan/GetStarted";
import Configure from "../SecurityHub/CreateNewScan/Configure";
import Review from "../SecurityHub/CreateNewScan/Review";

export default function Technology() {
  const [selectedProvider, setSelectedProvider] = useState("");
  const [service, setService] = useState("");
  const [step, setStep] = useState("");
  const [scope, setScope] = useState("");
  const [uploadedJson, setUploadedJson] = useState(null);

  const [formDataAWS, setFormDataAWS] = useState({
    accname: "",
    accID: "",
    role: "",
  });
  const [formDataAzure, setFormDataAzure] = useState({
    tenantID: "",
    accname: "",
    subID: "",
    appID: "",
    appClientSecret: "",
  });
  const [formDataGCP, setFormDataGCP] = useState({
    accname: "",
    prjID: "",
  });
  const navigate = useNavigate();

  const gridItem = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    border: "1px solid #ccc",
    backgroundColor: "#f4f4f4",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "transform 0.2s",
  };

  const handleIntegrationSelect = (integrationName) => {
    setSelectedProvider(integrationName);
    // navigate("/newIntegration");
  };
  const hanldeServiceProviderSelect = (providername) => {
    setService(providername);
    // navigate("/newIntegration");
  };

  const handleServiceProvider = () => {
    if (!selectedProvider || !service) return;
    if (selectedProvider === "Azure") {
      navigate("/inventory/azure");
    }
    if (selectedProvider === "GCP") {
      navigate("/inventory/gcp");
    }

    const routes = {
      AWS: "technology/aws",
      // Azure: "technology/azure",
      // GCP: "technology/gcp",
    };
    const routePath = routes[selectedProvider];
    if (routePath) {
      navigate(`/${routePath}/${service}`);
    }
  };

  //   const handleServiceProvider = () => {
  //     if (selectedProvider == "AWS") {
  //       navigate(`aws/${serviceProvider}`);
  //     }
  //     if (selectedProvider == "Azure") {
  //       navigate(`azure/${serviceProvider}`);
  //     }
  //     if (selectedProvider == "GCP") {
  //       navigate(`gcp/${serviceProvider}`);
  //     }
  //   };

  const buttons = [
    { name: "Entitlement", value: "entitlement" },
    { name: "Compute", value: "compute" },
    { name: "Application", value: "application" },
    { name: "Networking", value: "networking" },
    { name: "Data", value: "data" },
    { name: "AI & ML", value: "ai_ml" },
    { name: "CI/CD", value: "ci_cd" },
    { name: "Security", value: "security" },
  ];

  return (
    <div className="app-main__inner !pl-20">
      <Card
        className="h-full w-full rounded-3xl shadow-xl"
        style={{ backgroundImage: `url('/assets/images/beams.jpg')` }}
      >
        <>
          <CardHeader
            floated={false}
            shadow={false}
            className=" bg-transparent rounded-none"
          >
            <Typography
              variant="h4"
              color="blue-gray"
              className="mb-2 text-blue-gray-800"
            >
              List of Technologies
            </Typography>
            <Typography
              variant="h6"
              color="blue-gray"
              className="mb-4 !text-blue-gray-700 !font-normal"
            >
              View all cloud assets per technology
            </Typography>
          </CardHeader>
          <CardBody>
            <div className="grid grid-cols-3 gap-5">
              <div
                style={{
                  ...gridItem,
                  border:
                    selectedProvider === "AWS"
                      ? "2px solid 	#1E90FF"
                      : "1px solid #ccc",
                  backgroundColor:
                    selectedProvider === "AWS" ? "lightblue" : "",
                }}
                onClick={() => handleIntegrationSelect("AWS")}
              >
                <img src={AWS} alt="AWS" className="rounded-lg w-20 h-auto" />
                <Typography
                  variant="p"
                  color="blue-gray"
                  className="mt-2 font-semibold"
                >
                  Amazon Web Services
                </Typography>
              </div>
              <div
                style={{
                  ...gridItem,
                  border:
                    selectedProvider === "Azure"
                      ? "2px solid 	#1E90FF"
                      : "1px solid #ccc",
                  backgroundColor:
                    selectedProvider === "Azure" ? "lightblue" : "",
                }}
                onClick={() => handleIntegrationSelect("Azure")}
              >
                <img
                  src={Azure}
                  alt="Azure"
                  className="rounded-lg w-20 h-auto"
                />
                <Typography
                  variant="p"
                  color="blue-gray"
                  className="mt-2 font-semibold"
                >
                  Azure Cloud
                </Typography>
              </div>
              <div
                style={{
                  ...gridItem,
                  border:
                    selectedProvider === "GCP"
                      ? "2px solid 	#1E90FF"
                      : "1px solid #ccc",
                  backgroundColor:
                    selectedProvider === "GCP" ? "lightblue" : "",
                }}
                onClick={() => handleIntegrationSelect("GCP")}
              >
                <img src={GCP} alt="GCP" className="rounded-lg w-20 h-auto" />
                <Typography
                  variant="p"
                  color="blue-gray"
                  className="mt-2 font-semibold"
                >
                  Google Cloud Platform
                </Typography>
              </div>
            </div>
            <div className="grid grid-cols-4 gap-4 p-4">
              {buttons.map((button, index) => (
                <Button
                  key={index}
                  style={{
                    border:
                      service === button.value
                        ? "2px solid 	#1E90FF"
                        : "1px solid #ccc",
                  }}
                  //className="py-2 px-4 bg-blue-500 text-white rounded-md shadow hover:bg-blue-600 transition"
                  onClick={() => hanldeServiceProviderSelect(button.value)}
                >
                  {button.name}
                </Button>
              ))}
            </div>
          </CardBody>
          <CardFooter>
            <div className="flex flex-row gap-5 justify-end">
              <Button
                variant="gradient"
                color="light-blue"
                disabled={!selectedProvider || !service}
                // onClick={() => {
                //   setStep("Get Started");
                // }}
                onClick={handleServiceProvider}
              >
                Next
              </Button>

              <Button
                variant="text"
                color="red"
                //   onClick={() => {
                //     navigate("/inventory/assets");
                //   }}
              >
                Cancel
              </Button>
            </div>
          </CardFooter>
        </>
      </Card>
    </div>
  );
}
